export const APP_CONFIG = {
  // API_URL: process.env.REACT_APP_BACKEND_URL,
  API_URL: "https://api.counvo.in/",
   // API_URL: "http://localhost:5000/",
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
  AGORA_APP_ID: process.env.REACT_APP_AGORA_APP_ID,
  RAZORPAY_KEY_ID: process.env.REACT_APP_RAZORPAY_KEY_ID,
  NAVIGATION_HEADER_HEIGHT: 70,
  NAVIGATION_SIDEBAR_WIDTH: 260,
  SIDE_PANEL_WIDTH: 260,
  SIDE_PANEL_COLLAPSED_WIDTH: 80,
};
